// removed by extract-text-webpack-plugin
module.exports = {"signature":"_2uUrPJZS-4ST2VB72DYDZP"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/Field/Signature/Image/styles.css
// module id = 3128
// module chunks = 0